var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgYourTrace(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 10.583333 10.583334",
    id: "svg1",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs1"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "layer1"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.0136593,0,0,-0.0136593,0.62532977,10.359895)",
    fill: "#505050",
    stroke: "none",
    id: "g6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 279.73901,712.84066 c 4,-10 49,-14 171,-16 l 167,-2 2,-277 c 2,-210 6,-277 16,-281 9,-3 12,60 12,292 v 296 h -186 c -144,0 -185,-3 -182,-12 z",
    id: "path1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 217.73901,654.84066 c 0,-6 63,-10 170,-10 h 170 v -280 c 0,-242 2,-279.999998 15,-279.999998 13,0 15,38.999998 15,289.999998 v 290 h -185 c -117,0 -185,-4 -185,-10 z",
    id: "path2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 114.73901,566.84066 c -35.000002,-35 -37.000002,-42 -37.000002,-100 0,-35 4,-62 10,-62 6,0 10,24 10,53 0,48 3.000002,56 38.000002,90 l 38,38 165,-3 164,-3 3,-263 2,-261.999998 h -205 -205.000002 v 30 c 0,16.999998 -4,29.999998 -10,29.999998 -5,0 -10,-19.999998 -10,-44.999998 v -45 h 225.000002 225 v 289.999998 290 h -188 -188 z",
    id: "path3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 177.73901,534.84066 c 0,-27 -3,-30 -30,-30 -20,0 -30,-5 -30,-15 0,-11 12,-15 45,-15 h 45 v 45 c 0,33 -4,45 -15,45 -10,0 -15,-10 -15,-30 z",
    id: "path4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 62.739008,374.84066 c -69.0000003,-28 -96,-127 -53.0000003,-190 15.0000003,-23 38.0000003,-40 66.0000003,-50 38.000002,-13 47.000002,-13 90.000002,2 l 47,17 35,-34 c 33,-31.999998 60,-44.999998 60,-27.999998 0,4 -18,25.999998 -41,48.999998 -37,38 -40,44 -29,64 7,14 10,42 7,69 -7,64 -58,111 -119,110 -24,0 -52.000002,-4 -63.000002,-9 z m 88.000002,-19 c 72,-28 92,-118 38,-172 -90.000002,-88.999998 -228.000002,36 -150.000002,135 33,42 69.000002,53 112.000002,37 z",
    id: "path5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 63.739008,302.84066 c -18,-25 -21,-58 -6,-58 6,0 15,12 20,26 6,14 19,28 30.000002,31 28,7 25,23 -4,23 -14.000002,0 -32.000002,-10 -40.000002,-22 z",
    id: "path6"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYourTrace);
export default __webpack_public_path__ + "static/media/your-trace.00b747da74e77b26774d0de570729c25.svg";
export { ForwardRef as ReactComponent };